import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-update-modal',
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.scss'],
  standalone: false,
})
export class UpdateModalComponent {
  @Input() features: string[] = [];

  @Output() update = new EventEmitter<void>();

  constructor(public modal: NgbActiveModal) {}

  onUpdate() {
    this.update.emit();
    this.modal.close();
  }

  onCancel() {
    this.modal.dismiss();
  }
}
